import { Navigate } from "react-router-dom";

export default function AdminUsersTab() {
  return <Navigate to="/admin-users" replace />;
}
